import fetch from 'services'

export const getScene = (id) => fetch(`/scenes/${id}`)

export const getScenes = () => fetch(`/scenes/?thumbnails[0][width]=500&include_stock=True`)
